import { render } from "./WhatWeDo.vue?vue&type=template&id=2e4e93d7&scoped=true"
const script = {}

import "./WhatWeDo.vue?vue&type=style&index=0&id=2e4e93d7&scoped=true&lang=scss"

import exportComponent from "/Users/stepanmaksimov/Documents/Claude/Projects/A.sk/answerio-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4e93d7"]])

export default __exports__